export const ListQueryKey = 'innerTransConfigs';
export const DetailQueryKey = 'innerTransConfig';

export const Urls = {
  selectUrl: '/innerTransConfig/list',
  updateUrl: '/innerTransConfig/update',
  deleteUrl: '/innerTransConfig/delete',
  createUrl: '/innerTransConfig/create',
  detailUrl: '/innerTransConfig/detail',
};
